// extracted by mini-css-extract-plugin
module.exports = {"AboutInfoBlock":"AboutInfoBlock_AboutInfoBlock__WhMZV"};